<!-- TEMPLATE -->
<template>
  <div class="product-summary">
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>Odido Products</span>
            </span>

          <dean-section-title-item
              :icon='plusIcon'
              :content="true"
              @click.native="sectionRoute('standingData.odidoProducts.add')"
          >
            Odido product toevoegen
          </dean-section-title-item>
        </dean-section-title>

        <dean-table
            :data='productsData'
            :columns="columns"
            :hover="true"
            @column-click='columnClick'
            @cell-click="cellClick($event, 'standingData.odidoProducts.edit')">
        </dean-table>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import { Component } from 'vue-property-decorator';
import deanTableMixin from '@/mixins/deanTableMixin';
import {mixins} from 'vue-class-component';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';

import {
  // ICONS
  plusIcon,
  // COMPONENTS
  deanSectionTitle,
  deanSectionTitleItem,
  deanTable,
  deanPagination,
} from '@deanone/dean-components';
import {requestOdidoProducts} from "@/store/standingData/actions";

@Component({
  components: {
    plusIcon,
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanPagination,
    deanFormRow,
  },
})

export default class List extends mixins(deanTableMixin) {
  public products: any = [];
  public plusIcon: object = plusIcon;
  public queryTimeout!: number;

  // COMPUTED
  get productsData() {
    return this.products;
  }

  public columns: { [name: string]: object } = {
    name: {
      content: 'Naam',
      sort: false,
      align: 'left',
    },
    type: {
      content: 'Type',
      sort: false,
      align: 'left',
    },
  };

  get sideMenu(): object {
    return {
      title: {
        text: 'Odido Products',
        mobile: {
          close: {
            text: 'Close',
          },
        },
      },
      filters: {},
    };
  }

  public tableName(): string {
    return 'settings-odido-products';
  }

  // METHODS
  public loadList(): void {
    this.$store.dispatch('setLoadOverlay', true);
    this.$store.dispatch('requestOdidoProducts')
        .then(
            (response: any) => {
              this.products = response.data.map((products: any) => {
                return {
                  id: products.uuid,
                  name: products.name,
                  type: products.type === 'main' ? 'Belangrijkste product' : 'Optieproduct' ,
                };
              });
            },
            (error: any) => {
              this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
            },
        )
        .finally(
            () => {
              this.$store.dispatch('setLoadOverlay', false);
            },
        );
  }

  public cellClick(target: any): void {
    this.$router.push({
      name: 'standingData.odidoProducts.edit',
      params: {id: target.row.id},
    });
  }

  public created() {
    this.setDefaultSort('name');

    this.loadList();

    this.$store.dispatch('setStandingDataSideMenu', this.sideMenu);
  }

  public update(timeout: boolean) {
    if (timeout) {
      if (this.queryTimeout) {
        clearTimeout(this.queryTimeout);
      }
      this.queryTimeout = setTimeout(() => {
        this.loadList();
      }, 500);
    } else {
      this.loadList();
    }
  }
}
</script>
<!-- STYLE -->
<style lang="scss" scoped>
@import '~@deanone/dean-components/src/scss/vars';

filter {
  display: flex;
}

.top-bar {
  display: inline-block;
}
</style>